import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-register-soon',
  templateUrl: './register-soon.component.html',
  styleUrls: ['./register-soon.component.scss']
})
export class RegisterSoonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
